module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!-- Dropdown -->\n<div class="nav-dropdown-container';
 if (userRole !== 'Spectator' && (unconfirmed || type === 'ReadOnly')) {;
__p += ' action';
};
__p += '">\n    <span class="action-indicator">&excl;</span>\n    <div class="nav-dropdown">\n        <div class="mini-profile">\n            <div class="name">' +
__e( userName ) +
'\n                ';
 if (userName !== principalName) {;
__p += '<span class="principal"> (' +
__e(principalName) +
')</span>';
 } ;
__p += '\n            </div>\n            <div class="role">\n                ';
 if (userRole === principalRole) {;
__p +=
__e( userRole );
 } else {;
__p += '<span class="inactive">' +
__e( userRole ) +
'</span>';
 };
__p += '\n                ';
 if (userRole !== principalRole || type === "AD") {;
__p += '<span class="principal"> (' +
__e(principalRole) +
')</span>';
 } ;
__p += '\n            </div>\n            ';
 if (unconfirmed) {;
__p += '\n            <a class="settings-item icon-sign-in resend-confirmation ' +
__e( userRole ) +
'" href="#user/requestConfirmEmail">Confirm Your Identity</a>\n            ';
 } else if (type === "ReadOnly") {;
__p += '\n            <a class="settings-item icon-sign-in sign-in-again ' +
__e( userRole ) +
'" href="#login">Sign In Again</a>\n            ';
 } ;
__p += '\n            <a class="settings-item icon-log-out" href="#logout">Sign Out</a>\n            <hr>\n        </div>\n        <a class="settings-item icon-stats" href="#analytics">Set Up Analytics</a>\n        ';
 if (fontsIntegrationEnabled) { ;
__p += '\n        <a class="settings-item icon-fonts" href="#fonts">Set Up Fonts</a>\n        ';
 } ;
__p += '\n        <a class="settings-item icon-integrations" href="#integrations">Set Up Integrations</a>\n        ';
 if (designFileUIEnabled && !newDashboardExperience) { ;
__p += '\n        <a class="settings-item icon-psd-import" href="#designtransform">Transform Design File</a>\n        ';
 } ;
__p += '\n        <a class="settings-item icon-breakpoints" href="#breakpoints">Set Up Breakpoints</a>\n        ';
 if (zsitesEnabled) { ;
__p += '\n        <a class="settings-item icon-microsites">' +
((__t = ( zsitesHTML )) == null ? '' : __t) +
'</a>\n        ';
 } ;
__p += '\n        ';
 if (experienceExportEnabled) { ;
__p += '\n        <a class="settings-item icon-stats" href="#export" >' +
((__t = ( experienceExportHTML )) == null ? '' : __t) +
'</a>\n        ';
 } ;
__p += '\n        <a class="settings-item icon-manage-account" href="#manageAccount">Manage Account</a>\n\n    </div>\n</div>\n<!-- / Dropdown -->\n\n<a class="help-link" href="' +
__e( config.communityBaseUrl ) +
'/hc/en-us/requests/new" target="_blank" class="nav-item-settings">Help</a>\n\n<div class="guided-tour-nav">\n    <span class="guided-tour-nav-icon">Guide</span>\n</div>\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/common/NavBarCurrentPrincipalView.tpl
// module id = 2804
// module chunks = 0